import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import MapaVeiculo from '../mapa-veiculo/MapaVeiculo';
import alterarExibicaoDetalhamentoVeiculo from '../../actions/veiculo/alterarExibicaoDetalhamentoVeiculo';
import $ from 'jquery';
import buscarLocalizacaoVeiculo from '../../actions/veiculo/buscarLocalizacaoVeiculo';
import Autorizacao from '../../security/Autorizacao';
import { getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, getGestorOperacoes, PERFIL_ADMIN } from '../../security/securityContext';
import ImageGrid from './ImageGrid';
import Modal from './Modal';
import selecionarVeiculo from '../../actions/veiculo/selecionarVeiculo';

export class Veiculo extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedImg: null,
        }
    }

    buscarLocalizacao() {
        this.props.buscarLocalizacaoVeiculo(this.props.veiculo.id, this.props.empresaSelecionada.id).then(() => {
            $('#modalLocalizacaoVeiculo')
                .modal('show');
        })
    }

    setSelectedImg(selectedImg) {
        this.setState({ selectedImg })
    }

    exibieImagem() {
        let imagens = this.props.veiculo.imagens;        
        return (
            <div className="mr-3">
                <><ImageGrid setSelectedImg={this.setSelectedImg.bind(this)} veiculo={imagens.find(it => it.principal)} tipoVeiculo={this.props.veiculo.tipoVeiculo} />
                    {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}</>
            </div>

        )
    }

    render() {
        return (
            <React.Fragment>
                <div className="geral">
                    <div className="resumo">
                        <div className="row">
                            <div className="col-lg-1 col-xl-1"
                                onClick={() => this.props.alterarExibicaoDetalhamentoVeiculo(this.props.veiculo)}
                                style={{ cursor: 'pointer' }}>
                                {this.props.veiculo.exibirDetalhe ?
                                    <i className="material-icons" style={{ cursor: 'pointer' }}>
                                        &#xe5c7;
                                    </i> : <i className="material-icons" style={{ cursor: 'pointer' }}>
                                        &#xe5c5;
                                    </i>}
                            </div>
                            {this.exibieImagem()}
                            <div className="col-2 ml-5 text-center align-self-center">
                                <span className="titulo-mobile">Descrição:&nbsp;</span>{this.props.veiculo.descricao}
                            </div>

                            <div className="col-2 col-lg-2 col-xl-3 text-center align-self-center">
                                <span
                                    className="titulo-mobile">Quantidade Assentos:&nbsp;</span>{this.props.veiculo.mapaVeiculoDto.quantidadeAssentos}
                            </div>                            
                                <div className="col-lg-2 col-xl-3 align-self-center text-right">
                                    <div className="acoes">
                                        <div className="botoes">
                                        <Autorizacao
                                            perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                                                getGestorOperacoes(this.props.empresaSelecionada.id),
                                                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                            <button type="button" className="btn btn-excluir"
                                                data-toggle="modal" key={this.props.veiculo.id}
                                                data-target="#modalConfirmacaoExclusaoVeiculo"
                                                onClick={() => this.props.selecionar(this.props.veiculo)}>
                                                <i className="material-icons nav-icon">&#xe872;</i>
                                            </button>
                                            <button type="button" className="btn btn-editar ml-1"
                                                onClick={() => {
                                                    this.props.selecionarVeiculo(this.props.veiculo)
                                                    this.props.history.push('/painel-cadastro-veiculo')
                                                }}>
                                                <i className="material-icons nav-icon">&#xe150;</i>
                                            </button>
                                            {this.props.veiculo.idRastreamento ?
                                                <button type="button" className="btn btn-excluir ml-1"
                                                    title='Localização do itinerário'
                                                    onClick={() => this.buscarLocalizacao()}>
                                                    <i className="material-icons nav-icon">&#xe55b;</i>
                                                </button> : ''}
                                        </Autorizacao>
                                        <Autorizacao
                                            perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                                                getGestorOperacoes(this.props.empresaSelecionada.id),
                                                getOperadorEmpresa(this.props.empresaSelecionada.id), getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                                            <button id='buttonRegistrarManutencaoVeiculo' type="button" className="btn ml-2"
                                                title='Registrar manutenção veículo'                                                
                                                onClick={() => this.props.history.push(`/painel-registro-manutencao-veiculo?veiculo=${this.props.veiculo.id}`)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tools" viewBox="0 0 16 16">
                                                    <path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708M3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"/>
                                                </svg>
                                            </button>
                                        </Autorizacao>
                                        </div>
                                    </div>
                                </div>                            
                        </div>
                    </div>
                </div>
                {this.props.veiculo.exibirDetalhe ? <MapaVeiculo mapaVeiculo={this.props.veiculo.mapaVeiculoDto} /> : ''}
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
    });


export default withRouter(connect(mapStateToProps, {
    changeFieldValue,
    alterarExibicaoDetalhamentoVeiculo,
    buscarLocalizacaoVeiculo,
    selecionarVeiculo
})(reduxForm({
    form: 'formularioPainelCadastroVeiculo'
})(Veiculo)))
